"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKEND_PORT = process.env.PORT || '2567';
exports.ROOM_NAME = 'room';
